import styled from 'styled-components/macro';

export const HoverBox = styled.div`
  transition: all 0.2s ease-in-out;
  padding: 7px;
  background: white;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  box-shadow: ${({ forType }) =>
    forType
      ? '0 0 4px 1px rgba(0, 0, 0, 0.24)'
      : '0 0 4px 1px rgba(0, 0, 0, 0.16)'};

  &:hover {
    background: #f6f6f6;
  }

  &:active,
  &:focus {
    background: #f6f6f6;
    transform: scale(0.95);
  }

  & .icon {
    color: ${({ color }) => color};
  }
`;

export const FocusBackground = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(3px);
  z-index: ${({ zIndex }) => (zIndex ? zIndex : 9998)};
  transition: all 0.3s ease-in-out;
  opacity: ${({ showBox }) => (showBox ? 1 : 0)};
  pointer-events: ${({ showBox }) => (showBox ? 'auto' : 'none')};
`;

export const CardContainer = styled.div`
  &,
  & > div {
    transition: all 0.2s ease-in-out;
  }

  overflow: hidden;
  padding: 25px;
  border-radius: 25px;
  background: white;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  ${({ minWidth }) =>
    minWidth &&
    `
  min-width: ${minWidth};

  @media screen and (max-width: 471px) {
  min-width: 90vw;
}

  `}

  pointer-events: ${({ showBox }) => (showBox ? 'auto' : 'none')};
  z-index: 9999;
  box-shadow: 0px 0px 10px 5px rgb(0 0 0 / 25%);
`;

export const ListLayout = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InlineLayout = styled.div`
  display: flex;
  justify-content: ${({ justifyContent }) =>
    justifyContent != '' ? justifyContent : 'initial'};
`;

export const Slider = styled.div`
  transition: transform 300ms;
  display: flex;
  width: 200%;
  height: 100%;
  transform: ${({ showBox }) =>
    showBox ? 'translateX(-50%)' : 'translateX(0)'};

  & > div {
    transition: all 0.2s ease-in-out;
  }

  ${({ screen }) =>
    screen == 'Mobile' &&
    ` 
    width: 200vw;
    & > div {
    transition: all 0.4s ease-in-out;
  }
  `}
`;

export const SliderSubCom = styled.div`
  transition: all 0.2s ease-in-out;
  width: 50%;

  ${({ screen }) =>
    screen == 'Mobile' &&
    ` 
width: 100vw;
  `}

  transform: ${({ showBox }) =>
    showBox ? 'translateX(-100%)' : 'translateX(0)'};
`;

export const Switch = styled.div`
  display: flex;
  align-items: center;

  & > div {
    background: ${({ value, color }) => (value ? color : '#c4c4c4')};
    transition: all 0.2s ease-in-out;
    width: ${({ height }) => `${height * 2}px`};
    height: ${({ height }) => `${height}px`};
    cursor: pointer;
    overflow: hidden;
    padding: ${({ height }) => `${Math.round(height / 5)}px`};
    border-radius: ${({ height }) => `${height}px`};

    &:hover > div {
      box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.17);
    }
    & > div {
      width: ${({ height }) => `${height}px`};
      height: ${({ height }) => `${height}px`};
      background: white;
      box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.09);
      transform: ${({ value }) =>
        value ? 'translateX(100%)' : 'translateX(0)'};
      transition: all 0.2s ease-in-out;
      border-radius: 50%;
    }
  }
`;

export const AlertContainer = styled.div`
  max-width: 80vw;

  @media screen and (max-width: 767px) {
    max-width: 75vw;
  }

  width: fit-content;
  padding: 30px 40px;

  background: white;
  font-weight: bold;
  border-radius: 20px;

  text-align: center;

  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: ${({ zIndex }) => zIndex};

  color: ${({ color }) => color && color};
  box-shadow: 0px 0px 7px 3px rgb(0 0 0 / 15%);
`;

export const TextBox = styled.textarea`
  transition: all 0.2s ease-in-out;
  border-radius: 7px;
  border: 2px solid transparent;
  box-sizing: border-box;
  color: black;
  background: white;

  padding: ${({ targetType }) =>
    targetType == 'task' ? '7px 13px' : '7px 8px'};

  &:hover,
  &:focus {
    background: ${({ targetType }) =>
      targetType == 'task'
        ? 'rgba(0,0,0,0.09)!important'
        : 'rgba(0,0,0,0.04)!important'};
  }
  &:focus {
    border-color: rgba(0, 0, 0, 0.25);
  }
`;

export const CustomInput = styled.textarea`
  transition: all 0.2s ease-in-out;
  border-radius: 15px;
  border: 2px solid transparent;
  box-sizing: border-box;
  padding: 6px 8px;
  width: fit-content;
  color: black;

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  background: rgba(0, 0, 0, 0.05);
  &:hover,
  &:focus {
    background: rgba(0, 0, 0, 0.1) !important;
  }
  &:focus {
    border-color: rgba(0, 0, 0, 0.25);
  }
  width: 100%;
  margin-bottom: 4px;

  font-weight: bold;
`;

export const InputBox = styled.input`
  transition: all 0.2s ease-in-out;
  border-radius: 10px;
  border: 2px solid transparent;
  box-sizing: border-box;
  padding: 7px 10px;
  color: black;

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  background: rgba(0, 0, 0, 0.05);
  &:hover,
  &:focus {
    background: rgba(0, 0, 0, 0.1) !important;
  }
  &:focus {
    border-color: rgba(0, 0, 0, 0.25);
  }
  width: 100%; ;
`;

export const CusButton = styled.div`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  transition: all 0.2s ease-in-out;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 12px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid transparent;
  color: ${({ color }) => color && color};
  background: ${({ bg }) => bg && bg};

  &:active {
    transform: scale(0.99);
  }
  width: 100%;

  ${({ disabled }) =>
    disabled &&
    `
      opacity: 0.5;
      pointer-events: none;

    `};

  ${({ normal, shadowBorder }) =>
    normal
      ? `
    &:hover {
      opacity: 0.8;
      
  }
    `
      : `

    &:hover {
    transform: translateY(5%);
    box-shadow: 0 3px 5px 2px rgba(0, 0, 0, 0.1);
    border-color: ${shadowBorder ? 'rgba(0, 0, 0, 0.05)' : 'transparent'};
  }

    `};
`;

export const Alert = styled.div`
  font-weight: bold;
  padding: 15px;
  border-radius: 15px;

  margin-bottom: 25px;

  color: ${({ color }) => color};
  background: ${({ bg }) => bg};
`;

export const Link = styled.p`
  cursor: pointer;
  text-decoration: underline;
  transition: all 0.2s ease-in-out;

  &:hover {
    opacity: 0.8;
  }
`;

export const Loading = styled.div`
  position: fixed;
  z-index: 99999;
  & > div {
    & > div {
      background: ${({ color }) => color}!important;
      border-radius: 5px;
      & > div {
        opacity: 0 !important;
      }
    }

    height: 4px !important;
  }
`;
